import { WidgetGroupingTableDataRow } from 'common/Widgets/types';

import { formatValueDifference } from '../../valueDifferenceUtils';
import { valueFormatter } from '../utils';

const getGroupedTableDataValue = (value: any) => (typeof value === 'object' && value !== null ? value.value : value);
const getGroupedTableDataDifference = (value: any) =>
  typeof value === 'object' && value !== null ? value.difference : undefined;

export const getGroupedTableDataCsv = (
  community: any,
  competitors: any[],
  data: WidgetGroupingTableDataRow[],
  type: number,
  valueDisplay?: number
) => {
  const communityUnitSource = community;
  const csvData: string[][] = [];
  const firstRowData = ['', community.comunity_name, ...competitors.map((c) => c.comunity_name)];
  csvData.push(firstRowData);
  data.forEach((row) => {
    const rowData = [
      row.rowName,
      ...row.rowValues.map((value) => {
        const formatted = valueFormatter(getGroupedTableDataValue(value), type, true, undefined, communityUnitSource);
        const diff = formatValueDifference(getGroupedTableDataDifference(value), type, valueDisplay, communityUnitSource);
        return diff ? `${formatted} ${diff}` : formatted;
      }),
    ];
    csvData.push(rowData);
  });

  return csvData;
};
